export const myDynosStore = (set, get) => ({
  userGrades: [],
  subjectWiseDynos: [],
  dynoStatuses: [],
  domain: {},
  addToClassStatus: {},
  selectedGrade: "",
  selectedGradeName: "",
  selectedSubjectName: "",
  selectedDomain: "",
  dynoTitle: "",
  domainName: "",
  isDynoTitleUpdating: false,
  isWorking: true,
  setUserGrades: (value) => set(() => ({ userGrades: value })),
  setSubjectWiseDynos: (value) => set(() => ({ subjectWiseDynos: value })),
  setDomain: (value) => set(() => ({ domain: value })),
  setSelectedGrade: (value) => set(() => ({ selectedGrade: value })),
  setSelectedDomain: (value) => set(() => ({ selectedDomain: value })),
  updateState: (value) => set(() => ({ ...value })),
  setIsWorking: (value) => set(() => ({ isWorking: value })),
});
